
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { updataStopReason, getStopReasonDetail } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiUpdataStopReason extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private responsibilityTypeList!: object[];
  private formInline: objAny = {
    stopCode: "",
    stopName: "",
    responsibilityType: ""
  };
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("stopReason.add");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    stopCode: [
      {
        required: true,
        message: i18n.t("stopReason.stopCodePl"),
        trigger: "blur"
      }
    ],
    stopName: [
      {
        required: true,
        message: i18n.t("stopReason.stopNamePl"),
        trigger: "blur"
      }
    ],
    responsibilityType: [
      {
        required: true,
        message: i18n.t("stopReason.responsibilityTypePl"),
        trigger: "change",
        type: "number"
      }
    ]
  };
  private isAdd = false;
  private stopCode = "";
  public open(item?: objAny) {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;
    if (!item) {
      this.isAdd = true;
      this.formInline.stopCode = "";
      this.formInline.stopName = "";
      this.modalTitle = i18n.t("stopReason.add");
    } else {
      this.isAdd = false;
      this.formInline.stopCode = item.stopCode + "";
      this.formInline.stopName = item.stopName + "";
      this.formInline.responsibilityType = item.responsibilityType;
      this.stopCode = item.stopCode;

      this.modalTitle = i18n.t("stopReason.updata");
      // this.getStopReasonDetail();
    }
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    const ret = await updataStopReason(json);
    if (ret.status === this.$config.apiStatus) {
      if (this.isAdd) {
        this.$Message.success(i18n.t("addSuccess"));
      } else {
        this.$Message.success(i18n.t("updateSuccess"));
      }
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  async getStopReasonDetail(): Promise<void> {
    this.loading = true;
    const ret = await getStopReasonDetail({ stopCode: this.stopCode });
    if (ret.status === this.$config.apiStatus) {
      this.formInline.stopCode = ret.data[0].stopCode + "";
      this.formInline.stopName = ret.data[0].stopName + "";
    }
    this.loading = false;
  }
}
